import { escapeRegex } from './filters.util';

export const replaceConsecutiveSpacesWithHtmlSpaceCharacters = (
  originalString: string = '',
): string => {
  let htmlFormattedText = originalString;

  // Sometimes we may bind editor to null prop, protect against that here
  if (htmlFormattedText != null) {
    const regularExpression = new RegExp(escapeRegex('  '), 'gi');
    htmlFormattedText = htmlFormattedText.replace(
      regularExpression,
      '&nbsp;&nbsp;',
    );
  }

  return htmlFormattedText;
};
